import React, { useReducer, useState } from 'react';
import { View, StyleSheet, ScrollView, SafeAreaView } from 'react-native';
import Button, { BUTTON_TYPES } from '../Button';
import Modal from '../Modal';
import { CommonProperties, CommonStyles } from '../../styles';
import { CarCard, AirCard, HotelCard, RailCard, AirCardCloud } from '../resultCards';
import SummaryList from './SummaryList';
import AirSummaryList from './AirSummaryList';
import CarSummaryList from './CarSummaryList';
import HotelSummaryList from './HotelSummaryList';
import RailSummaryList from './RailSummaryList';
import BaseText from '../BaseText';
import { formatCurrency } from '../../utils/currency.utils';
import { addTextToCarName } from '../../utils/car.utils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import i18n, { i18nNS } from '../../i18n';
import { searchTypesEnum } from '../../constants/Enums';
import { useSelector } from 'react-redux';
import { selectAirComponents } from '../../store/selectors/air.selector';
import { selectAirTotalCloud } from '../../store/selectors/trip.selector';

const responseSelectedReducer = (state, action) => {
  switch (action.type) {
    case searchTypesEnum.AIR:
      return {
        title: i18n.t('tripSummary:GroupSummaryList.FlightDetails'),
        air: action.response,
      };
    case searchTypesEnum.CAR:
      return {
        title: i18n.t('tripSummary:GroupSummaryList.CarDetails'),
        car: action.response,
      };
    case searchTypesEnum.HOTEL:
      return {
        title: i18n.t('tripSummary:GroupSummaryList.HotelDetails'),
        hotel: action.response,
      };
    case searchTypesEnum.RAIL:
      return {
        title: i18n.t('tripSummary:GroupSummaryList.TextDetails'),
        rail: action.response,
      };
    default:
      return state;
  }
};

const GroupSummaryList = ({
  airList,
  carList,
  hotelList,
  railList,
  currency,
  currencyCulture,
  redeem,
}) => {
  const { t } = useTranslation(i18nNS.tripSummary);
  const [responseSelected, dispatchResponseSelect] = useReducer(responseSelectedReducer, {});
  const [showDetails, setShowDetails] = useState(false);
  const selectedAirComponents = useSelector(selectAirComponents);
  const airTotalPrice = useSelector(selectAirTotalCloud);
  const selectedFlights = Object.keys(selectedAirComponents)?.map(
    (key) => selectedAirComponents[key]['selectedAir']
  );
  const airFormat = [{ AirLegs: selectedFlights }];
  return (
    <View style={CommonStyles.flex1}>
      {selectedFlights[0]?.id
        ? airFormat?.map((response, index) => {
            return (
              <AirSummaryList
                key={index}
                response={response}
                currency={currency}
                currencyCulture={currencyCulture}
                redeem={redeem}
                price={airTotalPrice}
                onSelect={() => {
                  dispatchResponseSelect({
                    type: searchTypesEnum.AIR,
                    response,
                  });
                  setShowDetails(true);
                }}
              />
            );
          })
        : airList &&
          airList.map((response) => (
            <AirSummaryList
              key={response.ResponseID ? response.ResponseID : response.Id}
              response={response}
              currency={currency}
              currencyCulture={currencyCulture}
              price={response.TotalAmount}
              redeem={redeem}
              onSelect={() => {
                dispatchResponseSelect({
                  type: searchTypesEnum.AIR,
                  response,
                });
                setShowDetails(true);
              }}
            />
          ))}

      {hotelList &&
        hotelList.map((response) => (
          <HotelSummaryList
            key={response.HotelId + response.CheckInDate}
            response={response}
            currency={currency}
            currencyCulture={currencyCulture}
            onSelect={() => {
              dispatchResponseSelect({
                type: searchTypesEnum.HOTEL,
                response,
              });
              setShowDetails(true);
            }}
          />
        ))}
      {carList &&
        carList.map((response) => (
          <CarSummaryList
            key={response.ResponseId}
            response={response}
            currency={currency}
            currencyCulture={currencyCulture}
            onSelect={() => {
              dispatchResponseSelect({
                type: searchTypesEnum.CAR,
                response,
              });
              setShowDetails(true);
            }}
          />
        ))}
      {railList && railList && railList.RailLegs && railList.RailLegs.length > 0 && (
        <RailSummaryList
          response={railList}
          currency={currency}
          currencyCulture={currencyCulture}
          onSelect={() => {
            dispatchResponseSelect({
              type: searchTypesEnum.RAIL,
              response: railList,
            });
            setShowDetails(true);
          }}
        />
      )}
      <Modal visible={showDetails}>
        <SafeAreaView style={CommonStyles.flex1}>
          <ScrollView style={CommonStyles.flex1}>
            <View style={styles.header}>
              <BaseText style={CommonStyles.h3}>{responseSelected.title}</BaseText>
              <Button
                type={BUTTON_TYPES.TEXT}
                onPress={() => {
                  setShowDetails(false);
                }}
                label={t('common:Close')}
                style={styles.floatButton}
              />
            </View>
            {responseSelected.air && (
              <SummaryList>
                {responseSelected?.air?.AirLegs[0]?.id
                  ? responseSelected?.air?.AirLegs?.map((flight, index) => (
                      <AirCardCloud
                        key={index}
                        legIndex={0}
                        flight={flight}
                        textUpIcon={moment(flight.legs[0]?.flights[0]?.departureDate).format(
                          'MMM DD'
                        )}
                        value={
                          redeem
                            ? flight?.RedeemPoints + ' pts'
                            : formatCurrency(airTotalPrice, currency, currencyCulture)
                        }
                        currency={currency}
                        currencyCulture={currencyCulture}
                        visibleDetails
                        showBrands={index === 0}
                        showPerUnitPrice
                      />
                    ))
                  : responseSelected?.air?.AirLegs?.map((leg, index) => (
                      <AirCard
                        key={leg.LegNumber}
                        legIndex={index}
                        item={leg}
                        flight={responseSelected.air}
                        textUpIcon={
                          leg.AirSegments?.[0] &&
                          moment(leg.AirSegments[0].DepartureDate).format('MMM DD')
                        }
                        value={
                          redeem
                            ? responseSelected.air.RedeemPoints + ' pts'
                            : formatCurrency(
                                responseSelected.air.TotalAmount,
                                currency,
                                currencyCulture
                              )
                        }
                        currency={currency}
                        currencyCulture={currencyCulture}
                        visibleDetails
                        showBrands={index === 0}
                        showPerUnitPrice
                      />
                    ))}
              </SummaryList>
            )}
            {responseSelected.car && (
              <SummaryList>
                <CarCard
                  item={responseSelected.car}
                  subtitle={addTextToCarName(responseSelected.car?.CarName)}
                  textDownValue=" "
                  value={formatCurrency(
                    responseSelected.car?.MinimumFareTotal,
                    currency,
                    currencyCulture
                  )}
                  visibleDetails
                  showBrands
                  currency={currency}
                  currencyCulture={currencyCulture}
                  showPerUnitPrice
                />
              </SummaryList>
            )}
            {responseSelected.hotel && (
              <SummaryList style={CommonProperties.px3}>
                <HotelCard
                  item={responseSelected.hotel}
                  subtitle={responseSelected.hotel.CityName}
                  value={formatCurrency(
                    responseSelected.hotel.BaseRateTotalDays,
                    currency,
                    currencyCulture
                  )}
                  currency={currency}
                  currencyCulture={currencyCulture}
                  visibleDetails
                />
              </SummaryList>
            )}
            {responseSelected.rail && (
              <SummaryList>
                {responseSelected.rail.RailLegs.map((leg) => (
                  <RailCard
                    key={leg.LegNumber}
                    item={leg}
                    textUpIcon={leg.DepartDate}
                    visibleDetails
                    currency={currency}
                    currencyCulture={currencyCulture}
                  />
                ))}
              </SummaryList>
            )}
          </ScrollView>
        </SafeAreaView>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    height: 60,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  floatButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 60,
    justifyContent: 'center',
    ...CommonProperties.px4,
  },
});

export default GroupSummaryList;
